export type StudioFeatureKey =
  | "dashboard"
  | "requests"
  | "usage"
  | "STRANGER_FILES"
  | "consumers"
  | "patterns"
  | "review"
  | "dlq"
  | "rules"
  | "settings";

export type StudioFeatureNavGroup = "Monitor" | "Configure";

export interface StudioFeatureDefinition {
  key: StudioFeatureKey;
  label: string;
  routePath: string;
  navGroup: StudioFeatureNavGroup;
  displayOrder: number;
}

export class StudioFeatures {
  public static readonly DASHBOARD: StudioFeatureKey = "dashboard";
  public static readonly REQUESTS: StudioFeatureKey = "requests";
  public static readonly USAGE: StudioFeatureKey = "usage";
  public static readonly STRANGER_FILES: StudioFeatureKey = "STRANGER_FILES";
  public static readonly CONSUMERS: StudioFeatureKey = "consumers";
  public static readonly PATTERNS: StudioFeatureKey = "patterns";
  public static readonly REVIEW: StudioFeatureKey = "review";
  public static readonly DLQ: StudioFeatureKey = "dlq";
  public static readonly RULES: StudioFeatureKey = "rules";
  public static readonly SETTINGS: StudioFeatureKey = "settings";

  public static readonly ALL: StudioFeatureDefinition[] = [
    {
      key: StudioFeatures.DASHBOARD,
      label: "Dashboard",
      routePath: "/dashboard",
      navGroup: "Monitor",
      displayOrder: 10,
    },
    {
      key: StudioFeatures.REQUESTS,
      label: "Requests",
      routePath: "/requests",
      navGroup: "Monitor",
      displayOrder: 20,
    },
    {
      key: StudioFeatures.USAGE,
      label: "Usage",
      routePath: "/usage",
      navGroup: "Monitor",
      displayOrder: 30,
    },
    {
      key: StudioFeatures.STRANGER_FILES,
      label: "Stranger Files",
      routePath: "/stranger-files",
      navGroup: "Monitor",
      displayOrder: 35,
    },
    {
      key: StudioFeatures.CONSUMERS,
      label: "Consumers",
      routePath: "/consumers",
      navGroup: "Configure",
      displayOrder: 40,
    },
    {
      key: StudioFeatures.PATTERNS,
      label: "Patterns",
      routePath: "/patterns",
      navGroup: "Configure",
      displayOrder: 50,
    },
    {
      key: StudioFeatures.REVIEW,
      label: "Review Queue",
      routePath: "/review",
      navGroup: "Monitor",
      displayOrder: 60,
    },
    {
      key: StudioFeatures.DLQ,
      label: "DLQ",
      routePath: "/dlq",
      navGroup: "Monitor",
      displayOrder: 70,
    },
    {
      key: StudioFeatures.RULES,
      label: "Business Rules",
      routePath: "/rules",
      navGroup: "Configure",
      displayOrder: 80,
    },
    {
      key: StudioFeatures.SETTINGS,
      label: "Settings",
      routePath: "/settings",
      navGroup: "Configure",
      displayOrder: 90,
    },
  ];

  public static getFeatureEnvFlagKey(featureKey: StudioFeatureKey): string {
    return `VITE_FEATURE_${featureKey.toUpperCase()}`;
  }

  public static getByRoutePath(routePath: string): StudioFeatureDefinition | undefined {
    return StudioFeatures.ALL.find((feature) => feature.routePath === routePath);
  }

  public static getNavGroups(): StudioFeatureNavGroup[] {
    return ["Monitor", "Configure"];
  }
}
